module.exports = __webpack_public_path__ + "static/media/tachometer-slow.0600f69a.svg";